"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoSearchResult = void 0;
var react_1 = __importDefault(require("react"));
var useTranslationNs_1 = require("../../hooks/useTranslationNs");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NoSearchResult = function (_a) {
    var resetFilters = _a.resetFilters, appliedFiltersCount = _a.appliedFiltersCount;
    var translate = useTranslationNs_1.useTranslationNs('common', 'SEARCH_PAGE.NO_RESULTS');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.no_result },
        react_1.default.createElement("h2", null, translate('TITLE')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.no_result_description }, translate('DESCRIPTION')),
        appliedFiltersCount > 0 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.no_result_actions },
            react_1.default.createElement("a", { onClick: resetFilters },
                translate('CLEAR_FILTERS'),
                "(",
                appliedFiltersCount,
                ")")))));
};
exports.NoSearchResult = NoSearchResult;
